module.exports = __webpack_public_path__ + "img/que-on.e564764a.png";